// extracted by mini-css-extract-plugin
export default {"overlay":"TattooLightbox_overlay__fN-4m","imageShell":"TattooLightbox_imageShell__JyZKs","image":"TattooLightbox_image__CMSxD","closeButton":"TattooLightbox_closeButton__fPG8g"};